<script lang="ts">
	//UI
	import ComponentCover from "@hitit/hub/src/v7/components/common/ComponentCover.svelte";
	import ComponentLoading from "@hitit/hub/src/v7/components/common/ComponentLoading.svelte";
	import { AdaptiveTextInput, Card, DefaultSwitch } from "@hitit/new_ui";
	import EditIcon from "@hitit/hub/src/assets/Icons/Edit.png";
	import SaveIcon from "@hitit/hub/src/assets/Icons/Save.png";
	import { api, notifications, t } from "@hitit/hub/src/stores";
	import StoreNameValue from "@hitit/hub/src/v7/components/store/StoreNameValue.svelte";
	//Utils
	import { onlyNumberHandler } from "@hitit/hub/src/v7/utils";
	//Types
	import type { ATU_SettingDTO } from "@hitit/api";
	//Props
	export let AtuSetting: ATU_SettingDTO | null = null;
	export let coverStatus = false;
	export let editmode = false;
	export let editable = false;
	export let storeId = "";
	export let storeOwnerNumber = "";
	//Constants
	const message = "ATU 설정 저장 도중 문제가 발생하였습니다."
	//Variables
	let atuAvailable = false;
	let pinCode: string = "";
	let editMenuLocked = false;
	let viewSalesReportLocked = false;
	let editPointUserLocked = false;

	let loading = false;
	let error = "";

	//Functions
	async function actionHandler() {
		if (!editmode) {
			editmode = true;
			return;
		}

		try {
			// const atuSettingDTO = {
			// 	enabled: atuAvailable,
			// 	pinCode: pinCode === "없음" ? null : pinCode,
			// 	editMenuLocked,
			// 	viewSalesReportLocked,
			// 	editPointUserLocked,
			// 	editSettingLocked: atuAvailable,
			// };
			// await $api.setAtuSetting(storeId, atuSettingDTO);

			// error = "";
			alert('아직 사용할 수 없는 기능입니다. 서버에 저장되지 않습니다.')
			loading = true;

			editmode = false;
		} catch (error) {
			console.log(error);
			notifications.append("ERROR", message, "", undefined, "WARNING");
		} finally {
			loading = false;
		}
	}

	function atuFunctionChangeHandler(e: Event) {
		const target = e.target as HTMLInputElement;
		atuAvailable = target.checked ? true : false;
	}

	function editMenuChangeHandler(e: Event) {
		const target = e.target as HTMLInputElement;
		editMenuLocked = target.checked ? true : false;
	}
	function salesAnalysisChangeHandler(e: Event) {
		const target = e.target as HTMLInputElement;
		viewSalesReportLocked = target.checked ? true : false;
	}
	function earningCustomerChangeHandler(e: Event) {
		const target = e.target as HTMLInputElement;
		editPointUserLocked = target.checked ? true : false;
	}

	function dataConvert(atuSetting: ATU_SettingDTO | null) {
		atuAvailable = atuSetting ? atuSetting!.enabled : false;
		pinCode = atuSetting
			? atuSetting!.pinCode
				? atuSetting!.pinCode
				: "없음"
			: "없음";
		editMenuLocked = atuSetting ? atuSetting!.editMenuLocked : false;
		viewSalesReportLocked = atuSetting
			? atuSetting!.viewSalesReportLocked
			: false;
		editPointUserLocked = atuSetting ? atuSetting!.editPointUserLocked : false;
	}

	const inputHandler = (e: Event) => {
		const target = e.currentTarget as HTMLInputElement;
		onlyNumberHandler(target, (_, v) => {
			pinCode = v;
		});
	};

	//Do
	$: dataConvert(AtuSetting);
</script>

<div class="root-wrapper">
	<Card noPadding>
		<div class="container" t-id="AtuSettingWidget">
			{#if coverStatus}
				<ComponentCover />
			{/if}
			{#if loading}
				<ComponentLoading coverMode />
			{/if}
			{#if editable}
				<div class="action" on:click={actionHandler}>
					<span>{editmode ? $t("global.done") : $t("global.edit")}</span>
					<img
						src={editmode ? SaveIcon : EditIcon}
						alt={editmode ? "save" : "edit"}
					/>
				</div>
			{/if}
			<p class="title">{$t("hub.store.ATU_settings.ATU_setting")}</p>
			{#if editmode && error}
				<p class="error">{error}</p>
			{/if}

			<div class="header">
				<div class="name-value">
					<StoreNameValue
						name={$t("hub.store.ATU_settings.ATU_function")}
						editmode={editmode}
						value={atuAvailable === true
							? $t("hub.store.widget.cashreceipt.enabled")
							: $t("hub.store.widget.cashreceipt.disabled")}
					>
						<div slot="input" class="lock-box">
							<DefaultSwitch
								checked={atuAvailable === true}
								on:change={atuFunctionChangeHandler}
							/>
						</div>
					</StoreNameValue>
					{#if atuAvailable}
						<p class="approval-message">
							승인 알림톡은 {storeOwnerNumber}로 전송됩니다
						</p>
					{/if}
				</div>
				<div class="name-value">
					<StoreNameValue
						value={pinCode}
						name={$t("hub.store.ATU_settings.ATU_pincode")}
						editmode={editmode}
					>
						<div slot="input">
							<div class="input">
								<AdaptiveTextInput
									length={4}
									bind:value={pinCode}
									backgroundColor={"#f0f0f4"}
									on:input={inputHandler}
									clearCallback={() => (pinCode = "")}
								/>
							</div>
						</div>
					</StoreNameValue>
				</div>
			</div>
			{#if atuAvailable}
				<div class="rock-range-box">
					<p class="sub-title">{$t("hub.store.ATU_settings.ATU_lockrange")}</p>
					<div class="content-wrapper">
						<div class="name-value">
							<StoreNameValue
								name={$t("hub.store.ATU_settings.edit_menu")}
								editmode={editmode}
								value={editMenuLocked === true
									? $t("hub.store.widget.cashreceipt.enabled")
									: $t("hub.store.widget.cashreceipt.disabled")}
							>
								<div slot="input" class="lock-box">
									<DefaultSwitch
										checked={editMenuLocked === true}
										on:change={editMenuChangeHandler}
									/>
								</div>
							</StoreNameValue>
						</div>
						<div class="name-value">
							<StoreNameValue
								name={$t("hub.store.ATU_settings.sales_analysis")}
								editmode={editmode}
								value={viewSalesReportLocked === true
									? $t("hub.store.widget.cashreceipt.enabled")
									: $t("hub.store.widget.cashreceipt.disabled")}
							>
								<div slot="input" class="lock-box">
									<DefaultSwitch
										checked={viewSalesReportLocked === true}
										on:change={salesAnalysisChangeHandler}
									/>
								</div>
							</StoreNameValue>
						</div>
					</div>
					<div class="content-wrapper">
						<div class="name-value">
							<StoreNameValue
								name={$t("hub.store.ATU_settings.earning_customer_list")}
								editmode={editmode}
								value={editPointUserLocked === true
									? $t("hub.store.widget.cashreceipt.enabled")
									: $t("hub.store.widget.cashreceipt.disabled")}
							>
								<div slot="input" class="lock-box">
									<DefaultSwitch
										checked={editPointUserLocked === true}
										on:change={earningCustomerChangeHandler}
									/>
								</div>
							</StoreNameValue>
						</div>
					</div>
				</div>
			{/if}
		</div>
	</Card>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.root-wrapper {
		width: 100%;
	}
	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 10px;
		.title {
			font-size: 1.25rem;
			font-weight: 600;
			color: #46474b;
			padding: 20px 0px 0px 10px;
		}
		.action {
			display: flex;
			gap: 10px;
			align-items: center;
			position: absolute;
			right: 10px;
			top: 10px;
			color: #6d6f76;
			font-weight: 500;

			&:hover {
				cursor: pointer;
			}
			img {
				width: 24px;
				height: 24px;
				object-fit: contain;
			}
		}
		.header {
			display: flex;
			flex-direction: column;
			gap: 20px;
			padding: 10px 10px 20px 10px;
		}
		.rock-range-box {
			display: flex;
			flex-direction: column;
			gap: 20px;
			padding: 20px 10px;
			margin-bottom: 20px;
			box-sizing: border-box;
			background-color: #e6e7ed;
			color: #46474b;

			.sub-title {
				font-size: 1.5rem;
				font-weight: 500;
				color: #46474b;
			}
		}
		.content-wrapper {
			display: flex;
			flex-direction: column;
			gap: 20px;
		}
		.name-value {
			display: flex;
			flex-direction: column;
			gap: 10px;
			width: 100%;
			max-width: 100%;
		}
		.approval-message {
			@include appleAdjustTextForSize(16, true);
			color: #46474b;
		}
	}
	@include DesktopSize {
		.root-wrapper {
			max-height: 530px;
		}
		.container {
			padding: 20px;
			gap: 30px;
			.title {
				padding: unset;
				font-size: 2.125rem;
				padding: 0px 0px 0px 10px;
			}
			.action {
				top: 20px;
				right: 20px;
				font-size: 1.25rem;
			}
			.header {
				flex-direction: row;
				gap: unset;
				padding: 0px 10px 0px 10px;
			}
			.rock-range-box {
				border-radius: 5px;
				gap: 30px;
				padding: 30px;
				margin-bottom: unset;
				margin-right: 10px;
			}
			.input {
				height: 40px;
				width: 100%;
				max-width: 100%;
				font-size: 1.25rem;
			}
			.content-wrapper {
				flex-direction: row;
				gap: unset;
			}
			.name-value {
				width: 50%;
				max-width: 50%;
			}
		}
	}
</style>
